import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './theme/global.css';
import App from './App.js';
import { IntlProvider } from 'react-intl';
import enMessages from './utils/locales/en.json';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  tracePropagationTargets: ['localhost', import.meta.env.VITE_CREATOR_URL]
});

const messages: Record<string, Record<string, string>> = {
  en: enMessages
};
const defaultLocale = 'en';
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <IntlProvider locale={defaultLocale} messages={messages[defaultLocale]}>
      <App />
    </IntlProvider>
  </StrictMode>
);
